import { render, staticRenderFns } from "./RegistrationsAndPlans.vue?vue&type=template&id=9c7869d0&scoped=true"
import script from "./RegistrationsAndPlans.vue?vue&type=script&lang=js"
export * from "./RegistrationsAndPlans.vue?vue&type=script&lang=js"
import style0 from "./RegistrationsAndPlans.vue?vue&type=style&index=0&id=9c7869d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7869d0",
  null
  
)

export default component.exports